import { AdminTitle } from "@/admin/AdminTitle.tsx";
import { AddAdminUserButton, EditAdminUserButton } from "@/admin/users/AddAdminUserModal.tsx";
import { adminUserDeleteMutation, adminUsersQueryAtom } from "@/admin/users/adminUsersQuery.ts";
import { WAdminTable } from "@/admin/WAdminTable.tsx";
import { WModalButton } from "@/components/button/WToolButton.tsx";
import { ClipBoardTooltip } from "@/components/ClipBoardTooltip.tsx";
import { DeleteModal } from "@/components/modal/DeleteModal.tsx";
import { WTableBody } from "@/components/table/WTable.tsx";
import { TODO } from "@/dev/Todo.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import type { ElevatedUser } from "@warrenio/api-spec/spec.oats.gen";
import { sortBy } from "remeda";

export function AdminUsersView() {
    const deleteMutation = useStandardMutation(adminUserDeleteMutation);
    const users = useSuspenseQueryAtom(adminUsersQueryAtom);

    async function onDelete({ username }: ElevatedUser) {
        await deleteMutation.mutateAsync({
            body: {
                username,
            },
        });
    }

    return (
        <>
            <AdminTitle title="Admin Users">
                <AddAdminUserButton button={<WModalButton label="New" color="primary" size="bar" variant="basic" />} />
            </AdminTitle>

            <WAdminTable>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Username</th>
                        <th>Role</th>
                        <th />
                    </tr>
                </thead>
                <WTableBody>
                    {sortBy(users, (u) => Number(u.custom_id)).map((item) => {
                        const { custom_id, username, role } = item;
                        return (
                            <tr key={username}>
                                <td>{custom_id && <ClipBoardTooltip hideIcon>{custom_id}</ClipBoardTooltip>}</td>
                                <td>
                                    <TODO small title="Link to user table" />
                                    <ClipBoardTooltip hideIcon>{username}</ClipBoardTooltip>
                                </td>
                                <td>{role}</td>
                                <td className="text-right">
                                    <div className="flex gap-0.5em justify-end">
                                        <EditAdminUserButton item={item} />
                                        <DeleteModal inTable modalAction={async () => await onDelete(item)}>
                                            Are you sure you want to remove admin user "<b>{username}</b>"?
                                        </DeleteModal>
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </WTableBody>
            </WAdminTable>

            <div className="p-2">
                <AddAdminUserButton
                    button={
                        <WModalButton
                            className="w-full"
                            label="Add Admin User"
                            color="primary"
                            size="lg"
                            variant="dashed"
                            icon="jp-icon-add"
                        />
                    }
                />
            </div>
        </>
    );
}
